'use strict';

import angular from 'angular';
import Info from './info.controller';

import uiRouter from 'angular-ui-router';

export default angular.module('bfastCaptureManagerApp.application.info', [uiRouter])
  .controller('AppInfoController', Info)
  .name;



// WEBPACK FOOTER //
// ./client/app/application/info/index.js